exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[target=_blank][data-v-29194e64]:after{font-family:FontAwesome;content:\" \\F08E\"}.toggle-container .panel.style1 .panel-content[data-v-29194e64]{padding:10px 40px 15px 55px}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-29194e64]{font-size:1.5em}.toggle-container .panel h4.panel-title[data-v-29194e64]{font-size:1.2em}.toggle-container .panel.style1 .panel-content[data-v-29194e64]{padding:10px 15px 15px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-29194e64","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/booking/pagecontent/FurtherServices.vue
// module id = 445
// module chunks = 0